import { LineChart, BarChart } from "../../v6common/Charts";
import { Blk, Qm } from "./useBlock";
import { pct, num, dayLabel, hourLabels, periodText, DASH } from "./format";

const C = (color, text) => <span style={{ color }}>{text}</span>;

export function PerfPanel({ days, summary }) {
    return (
        <div className="panel mt" role="region" aria-label="챗봇 성능 지표">
            <div className="pn-h"><h3><i className="fa-solid fa-chart-line" style={{ color: "var(--pri)" }}></i> 챗봇 성능 지표</h3></div>
            <Blk st={summary}>{(s) => {
                const r = s.inquiry_resolution || {};
                return (
                    <div className="pn grid4">
                        <Qm n={C("#15803d", pct(r.rate))} l="문의 해결률" f={`완료 ${r.completed ?? DASH}건 ÷ 전체 문의 ${r.total ?? DASH}건`} />
                        <Qm n={C("var(--pri)", `${num(s.avg_first_response_sec, 2)} 초`)} l="평균 응답 시간" f="질문 후 첫 답변까지" />
                        <Qm n={C("#7c3aed", `${num(s.avg_turns, 1)} 턴`)} l="평균 대화 턴수" f="한 대화에서 주고받은 메시지 수" />
                        <Qm n={C("#0f766e", `${num(s.conversations_per_day, 1)} 건/일`)} l="일평균 대화량" f={periodText(days)} />
                    </div>
                );
            }}</Blk>
        </div>
    );
}

export function QualityPanel({ summary }) {
    return (
        <div className="panel" role="region" aria-label="품질 지표">
            <div className="pn-h"><h3>품질 지표</h3><span className="hint">로그 기반 자동 산출</span></div>
            <Blk st={summary}>{(s) => (
                <div className="pn grid3" style={{ height: "calc(100% - 49px)", alignContent: "center" }}>
                    <Qm n={pct(s.inquiry_resolution?.rate)} l="해결률" f="완료 ÷ 전체 접수" />
                    <Qm n={pct(s.requery_rate)} l="재질문율" f="유사질문 재발생 ÷ 세션" />
                    <Qm n={pct(s.escalation_rate)} l="확인필요" f="상담연결 전환 ÷ 대화" />
                </div>
            )}</Blk>
        </div>
    );
}

export function DailyPanel({ keys, daily, convs }) {
    return (
        <div className="panel" role="region" aria-label="일별 대화량">
            <div className="pn-h"><h3>일별 대화량</h3></div>
            <div className="pn">
                <Blk st={daily}>{() => <LineChart values={convs} labels={keys.map(dayLabel)} name="대화" height={210} />}</Blk>
            </div>
        </div>
    );
}

// hourly = 요약 블록 상태 — hourly_usage(대화 시작 시각 0~23시 24칸)를 그린다
export function HourlyPanel({ hourly }) {
    return (
        <div className="panel mt" role="region" aria-label="시간대별 대화량">
            <div className="pn-h"><h3>시간대별 대화량</h3></div>
            <div className="pn">
                <Blk st={hourly}>{(s) => <BarChart values={Array.from({ length: 24 }, (_, i) => Number(s?.hourly_usage?.[i]) || 0)} labels={hourLabels} name="대화" height={200} />}</Blk>
            </div>
        </div>
    );
}
